// ============================================================
// src/shack/shackItems.js
// Render y manejo de items del Shack 3D
// ============================================================

import { t } from '../i18n.js';
import { FRAME_GEOMETRY } from './shackConfig.js';
import { mostrarConfirmacion } from '../ui.js';
import { eliminarArchivoDeEdicion } from '../firestore.js';
import { getProvider } from '../storage/storage.js';

export function crearItemsApi(ctx) {
  const {
    state,
    mostrarToast,
    obtenerAccessToken,
    solicitarPermisosDrive,
    generarThumbnailsEnLote,
    abrirEncuadrador,
    limpiarCacheFrameTextures,
    crearMapaGroup,
    crearCertificadoGroup,
    aplicarTransformItem,
    guardarDebounced,
    ordenarPorZIndex,
    nextZIndex,
    selectedItem,
    mapUrl,
  } = ctx;

  function ensureMapExists() {
    // no obligatorio; solo evita duplicados cuando se agregue luego
  }

  async function cargarThumbnailsYRenderizar(certItems) {
    state.thumbs = await generarThumbnailsEnLote(certItems);
    await renderizarItems(state.thumbs);
  }

  function mostrarAvisoPendientesEncuadrar(sinEncuadrar, todosLosCerts) {
    document.getElementById('shack-aviso-encuadrar')?.remove();

    const aviso = document.createElement('div');
    aviso.id = 'shack-aviso-encuadrar';
    aviso.style.cssText = `
      position: absolute;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(10,10,14,0.95);
      border: 1px solid rgba(100,160,255,0.35);
      border-radius: 12px;
      padding: 16px 20px;
      display: flex;
      align-items: center;
      gap: 14px;
      z-index: 80;
      backdrop-filter: blur(8px);
      box-shadow: 0 8px 32px rgba(0,0,0,0.5);
      white-space: nowrap;
      font: 13px/1.4 system-ui, sans-serif;
      color: #c8d8ff;
    `;

    const n = sinEncuadrar.length;

    const icono = document.createElement('span');
    icono.style.fontSize = '20px';
    icono.textContent = '🖼️';

    const texto = document.createElement('span');
    texto.innerHTML = t('shack.aviso.pendientes', { n: `<strong>${n}</strong>` });

    const btnEncuadrar = document.createElement('button');
    btnEncuadrar.id = 'shack-btn-ir-encuadrar';
    btnEncuadrar.textContent = t('shack.aviso.encuadrar');
    btnEncuadrar.style.border = 'none';
    btnEncuadrar.style.background = '#3b6bff';
    btnEncuadrar.style.color = '#fff';
    btnEncuadrar.style.font = '600 12px/1 system-ui, sans-serif';
    btnEncuadrar.style.borderRadius = '8px';
    btnEncuadrar.style.padding = '8px 16px';
    btnEncuadrar.style.cursor = 'pointer';
    btnEncuadrar.style.flexShrink = '0';

    const btnOmitir = document.createElement('button');
    btnOmitir.id = 'shack-btn-omitir-encuadrar';
    btnOmitir.textContent = t('shack.aviso.omitir');
    btnOmitir.style.border = '1px solid rgba(255,255,255,.15)';
    btnOmitir.style.background = 'transparent';
    btnOmitir.style.color = 'rgba(255,255,255,.6)';
    btnOmitir.style.font = '13px/1 system-ui, sans-serif';
    btnOmitir.style.borderRadius = '8px';
    btnOmitir.style.padding = '8px 14px';
    btnOmitir.style.cursor = 'pointer';
    btnOmitir.style.flexShrink = '0';

    aviso.replaceChildren(icono, texto, btnEncuadrar, btnOmitir);

    state.host.style.position = 'relative';
    state.host.appendChild(aviso);

    document.getElementById('shack-btn-omitir-encuadrar')?.addEventListener('click', async () => {
      aviso.remove();
      const necesitaTokenDrive = todosLosCerts.some((i) => i.storageType !== 'managed_drive');
      if (necesitaTokenDrive && !obtenerAccessToken()) {
        mostrarAvisoDriveNoAutorizado(todosLosCerts);
      } else {
        await cargarThumbnailsYRenderizar(todosLosCerts);
      }
    });

    document.getElementById('shack-btn-ir-encuadrar')?.addEventListener('click', async () => {
      aviso.remove();

      const necesitaTokenDrive = todosLosCerts.some((i) => i.storageType !== 'managed_drive');
      if (necesitaTokenDrive && !obtenerAccessToken()) {
        mostrarAvisoDriveNoAutorizado(todosLosCerts);
        return;
      }

      state.thumbs = await generarThumbnailsEnLote(todosLosCerts);
      await renderizarItems(state.thumbs);

      await encuadrarItemDirecto(sinEncuadrar[0]);
    });
  }

  async function encuadrarItemDirecto(item) {
    const imgEl = state.imagenesCache.get(item.fileId);
    const urlImg = imgEl?.src || state.thumbs.get(item.fileId) || null;

    await abrirEncuadrador(item, urlImg, async (itemActualizado) => {
      const idx = state.items.findIndex((i) => i.shackKey === itemActualizado.shackKey);
      if (idx >= 0) state.items[idx] = { ...state.items[idx], ...itemActualizado };

      await renderizarItems(state.thumbs);
      guardarDebounced();

      const restantes = state.items.filter((i) => i.tipo === 'certificado' && !i.encuadrado);
      if (restantes.length > 0) {
        const todosLosCerts = state.items.filter((i) => i.tipo === 'certificado');
        mostrarAvisoPendientesEncuadrar(restantes, todosLosCerts);
      } else {
        mostrarToast(t('shack.toast.todos-encuadrados'), 'exito');
      }
    });
  }

  function mostrarAvisoDriveNoAutorizado(certItems) {
    renderizarItems(new Map());

    const aviso = document.createElement('div');
    aviso.id = 'shack-drive-aviso';
    aviso.style.cssText = `
      position: absolute;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(10,10,14,0.92);
      border: 1px solid rgba(255,200,60,0.35);
      border-radius: 12px;
      padding: 14px 20px;
      display: flex;
      align-items: center;
      gap: 14px;
      z-index: 80;
      backdrop-filter: blur(8px);
      box-shadow: 0 8px 32px rgba(0,0,0,0.5);
      white-space: nowrap;
      font: 13px/1.4 system-ui, sans-serif;
      color: #e8d8a0;
    `;

    const icono = document.createElement('span');
    icono.style.fontSize = '20px';
    icono.textContent = '🔑';

    const texto = document.createElement('span');
    texto.textContent = t('shack.aviso.drive.texto');

    const btnAutorizar = document.createElement('button');
    btnAutorizar.id = 'shack-btn-autorizar-drive';
    btnAutorizar.textContent = t('shack.aviso.drive.autorizar');
    btnAutorizar.style.border = 'none';
    btnAutorizar.style.background = '#f0a020';
    btnAutorizar.style.color = '#0a0808';
    btnAutorizar.style.font = '600 12px/1 system-ui, sans-serif';
    btnAutorizar.style.borderRadius = '8px';
    btnAutorizar.style.padding = '8px 16px';
    btnAutorizar.style.cursor = 'pointer';
    btnAutorizar.style.flexShrink = '0';

    const btnCerrar = document.createElement('button');
    btnCerrar.id = 'shack-btn-cerrar-aviso';
    btnCerrar.textContent = '✕';
    btnCerrar.style.border = 'none';
    btnCerrar.style.background = 'transparent';
    btnCerrar.style.color = 'rgba(255,255,255,0.4)';
    btnCerrar.style.fontSize = '16px';
    btnCerrar.style.cursor = 'pointer';
    btnCerrar.style.padding = '0 4px';
    btnCerrar.style.flexShrink = '0';

    aviso.replaceChildren(icono, texto, btnAutorizar, btnCerrar);

    state.host.style.position = 'relative';
    state.host.appendChild(aviso);

    document.getElementById('shack-btn-cerrar-aviso')?.addEventListener('click', () => {
      aviso.remove();
    });

    document.getElementById('shack-btn-autorizar-drive')?.addEventListener('click', async () => {
      const btn = document.getElementById('shack-btn-autorizar-drive');
      if (btn) {
        btn.textContent = t('shack.aviso.drive.autorizando');
        btn.disabled = true;
      }

      try {
        const ok = await solicitarPermisosDrive();
        if (ok) {
          aviso.remove();
          await cargarThumbnailsYRenderizar(certItems);
        } else if (btn) {
          btn.textContent = t('shack.aviso.drive.reintentar');
          btn.disabled = false;
        }
      } catch (e) {
        console.error('[Shack3D] Error al autorizar Drive:', e);
        if (btn) {
          btn.textContent = t('shack.aviso.drive.reintentar');
          btn.disabled = false;
        }
      }
    });
  }

  function precargarRatioImagen(blobUrl) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img.naturalWidth / img.naturalHeight);
      img.onerror = () => resolve(null);
      img.src = blobUrl;
    });
  }

  async function renderizarItems(thumbs) {
    if (!state.scene) return;

    state.meshes.forEach((g) => {
      g.traverse((child) => {
        if (!child.isMesh) return;
        child.geometry?.dispose();
        const mats = Array.isArray(child.material) ? child.material : [child.material];
        mats.forEach((m) => {
          if (!m) return;
          // No disponer texturas del frame ni del vidrio (son cacheadas y reutilizadas)
          if (m.map && !child.userData.isFrameMesh && !child.userData.isGlassMesh) m.map.dispose();
          m.dispose();
        });
      });
      state.scene.remove(g);
    });
    state.meshes = [];
    state.pickables = [];

    ordenarPorZIndex();

    const imagenesPrecargadas = new Map();
    const certItemsParaRender = state.items.filter(
      (item) => item.tipo === 'certificado' && item.visible !== false
    );

    await Promise.all(
      certItemsParaRender.map(async (item) => {
        const url = thumbs.get(item.fileId);
        if (!url) return;
        try {
          const img = await cargarImagen(url);
          imagenesPrecargadas.set(item.fileId, img);
          state.imagenesCache.set(item.fileId, img);
          if (img.naturalWidth && img.naturalHeight) {
            item.imgRatio = img.naturalWidth / img.naturalHeight;
            if (!item.frameRatioManual) {
              item.frameRatio = item.imgRatio * (FRAME_GEOMETRY.certRect.h / FRAME_GEOMETRY.certRect.w);
            }
          }
        } catch (e) {
          console.warn('[Shack3D] No se pudo precargar imagen', item.fileId, e);
        }
      })
    );

    const mapasPrecargados = new Map();
    const mapaItemsParaRender = state.items.filter(
      (item) => item.tipo === 'mapa' && item.visible !== false
    );
    await Promise.all(
      mapaItemsParaRender.map(async (item) => {
        const url = item.src || mapUrl;
        if (!url) return;
        try {
          const img = await cargarImagen(url);
          mapasPrecargados.set(item.shackKey, img);
        } catch (e) {
          console.warn('[Shack3D] No se pudo precargar mapa', item.shackKey, e);
        }
      })
    );

    state.items
      .filter((item) => item.visible !== false)
      .forEach((item) => {
        const group =
          item.tipo === 'mapa'
            ? crearMapaGroup(item, mapasPrecargados.get(item.shackKey))
            : crearCertificadoGroup(
                item,
                imagenesPrecargadas.get(item.fileId) ||
                  state.imagenesCache.get(item.fileId) ||
                  thumbs.get(item.fileId)
              );

        state.scene.add(group);
        state.meshes.push(group);
      });

    state.needsRender = true;
  }

  function cargarImagen(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('Error cargando imagen: ' + src));
      img.src = src;
    });
  }

  async function encuadrarSeleccionado() {
    const item = selectedItem();
    if (!item || (item.tipo !== 'certificado' && item.tipo !== 'mapa')) {
      mostrarToast(t('shack.toast.seleccionar-item'), 'ok');
      return;
    }

    const urlImg =
      item.tipo === 'mapa'
        ? (item.src || null)
        : (state.imagenesCache.get(item.fileId)?.src || state.thumbs.get(item.fileId) || null);

    await abrirEncuadrador(item, urlImg, async (itemActualizado) => {
      const idx = state.items.findIndex((i) => i.shackKey === itemActualizado.shackKey);
      if (idx >= 0) state.items[idx] = { ...state.items[idx], ...itemActualizado };
      limpiarCacheFrameTextures(state.frameModelTextureCache);
      await renderizarItems(state.thumbs);
      guardarDebounced();
      mostrarToast(t('shack.toast.cuadro-actualizado'), 'exito');
    });
  }

  async function agregarMapa() {
    if (state.items.find((i) => i.tipo === 'mapa')) {
      mostrarToast(t('shack.toast.mapa-existe'), 'ok');
      return;
    }

    const zIndex = nextZIndex();

    state.items.push({
      tipo: 'mapa',
      shackKey: 'mapa:yaesu',
      titulo: 'Yaesu World Map',
      src: mapUrl,
      expandible: true,
      wall: 'trasera',
      u: 0.58,
      v: 0.32,
      w: 0.62,
      h: 0.35,
      ratio: 1792 / 1224,
      frameTone: 0.10,
      zIndex,
      visible: true,
    });

    ordenarPorZIndex();
    await renderizarItems(state.thumbs);
    guardarDebounced();
    mostrarToast(t('shack.toast.mapa-agregado'), 'ok');
  }

  async function toggleWallSelected() {
    const item = selectedItem();
    if (!item) return;

    item.wall = item.wall === 'trasera' ? 'lateral' : 'trasera';
    item.u = 0.50;
    item.v = 0.35;

    if (item.wall === 'lateral') {
      item.w = Math.min(item.w, 0.48);
    }

    await renderizarItems(state.thumbs);
    guardarDebounced();
  }

  async function deleteSelected() {
    const item = selectedItem();
    if (!item) return;

    if (item.tipo !== 'certificado') {
      // Comportamiento original para mapas y otros elementos
      state.items = state.items.filter((i) => i.shackKey !== item.shackKey);
      state.selection.itemKey = null;
      await renderizarItems(state.thumbs);
      guardarDebounced();
      return;
    }

    // Certificado: validar campos requeridos antes de intentar borrar
    if (!item.edicionId || !item.archivoId || !item.storageType || !item.fileId) {
      mostrarToast(t('shack.toast.cert-error-datos'), 'error');
      console.error('[Shack][delete] Faltan datos en item:', item);
      return;
    }

    const confirmado = await mostrarConfirmacion(
      'Eliminar certificado',
      'Este certificado será eliminado definitivamente de Contest Manager, del Shack Virtual y del almacenamiento asociado. Esta acción no se puede deshacer.',
      { labelConfirmar: 'Eliminar', icono: '🗑️' }
    );
    if (!confirmado) return;

    // 1. Borrar del storage (si falla, no continuar)
    try {
      await getProvider(item.storageType).delete(item.fileId);
    } catch (err) {
      console.error('[Shack][delete] Error al borrar del storage:', err);
      mostrarToast(t('shack.toast.cert-error-storage'), 'error');
      return;
    }

    // 2. Borrar el registro de Firestore (si falla, reportar sin dejar UI en falso estado)
    try {
      await eliminarArchivoDeEdicion(item.edicionId, item.archivoId);
    } catch (err) {
      console.error('[Shack][delete] Error al borrar de Firestore:', err);
      mostrarToast(t('shack.toast.cert-error-firestore'), 'error');
      return;
    }

    // 3. Quitar del Shack local y guardar
    state.items = state.items.filter((i) => i.shackKey !== item.shackKey);
    state.selection.itemKey = null;
    await renderizarItems(state.thumbs);
    guardarDebounced();
    mostrarToast(t('shack.toast.cert-borrado'), 'exito');
  }

  function sameWallVisibleItems() {
    const sel = selectedItem();
    if (!sel) return [];

    return state.items
      .filter((i) => i.visible !== false && i.wall === sel.wall)
      .sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));
  }

  function alturaEfectiva(item) {
    if (item.frameRatio > 0) return item.w / item.frameRatio;
    if (item.ratio > 0) return item.w / item.ratio;
    return item.h > 0 ? item.h : item.w;
  }

  function seleccionMultiple() {
    const ref = selectedItem();
    if (!ref || !state.selection.selectedKeys?.size) return null;
    const items = [...state.selection.selectedKeys]
      .map((k) => state.items.find((i) => i.shackKey === k))
      .filter(Boolean)
      .filter((i) => i.wall === ref.wall);
    if (!items.length) return null;
    return { ref, items };
  }

  async function alignSelected(mode) {
    const sel = seleccionMultiple();
    if (!sel) {
      mostrarToast('Selecciona 2 o más cuadros de la misma pared.', 'ok');
      return;
    }
    const { ref, items } = sel;
    const refH = alturaEfectiva(ref);

    items.forEach((item) => {
      const itemH = alturaEfectiva(item);
      let nu = item.u;
      let nv = item.v;

      switch (mode) {
        case 'left':     nu = (ref.u - ref.w / 2) + item.w / 2; break;
        case 'center-h': nu = ref.u; break;
        case 'right':    nu = (ref.u + ref.w / 2) - item.w / 2; break;
        case 'top':      nv = (ref.v - refH / 2) + itemH / 2; break;
        case 'middle':   nv = ref.v; break;
        case 'bottom':   nv = (ref.v + refH / 2) - itemH / 2; break;
      }

      item.u = Math.max(item.w / 2, Math.min(1 - item.w / 2, nu));
      item.v = Math.max(itemH / 2, Math.min(1 - itemH / 2, nv));
    });

    await renderizarItems(state.thumbs);
    guardarDebounced();
  }

  async function distributeSelected(axis) {
    const sel = selectedItem();
    if (!sel) return;

    const group = sameWallVisibleItems();
    if (group.length < 3) return;

    if (axis === 'h') {
      const arr = [...group].sort((a, b) => a.u - b.u);
      const min = arr[0].u;
      const max = arr[arr.length - 1].u;
      const step = (max - min) / (arr.length - 1);
      arr.forEach((i, idx) => {
        i.u = min + (step * idx);
      });
    } else {
      const arr = [...group].sort((a, b) => a.v - b.v);
      const min = arr[0].v;
      const max = arr[arr.length - 1].v;
      const step = (max - min) / (arr.length - 1);
      arr.forEach((i, idx) => {
        i.v = min + (step * idx);
      });
    }

    await renderizarItems(state.thumbs);
    guardarDebounced();
  }

  function bringSelectedToFront() {
    const item = selectedItem();
    if (!item) return;
    item.zIndex = nextZIndex();
  }

  function sendSelectedToBack() {
    const item = selectedItem();
    if (!item) return;
    const min = Math.min(...state.items.map((i) => i.zIndex || 0));
    item.zIndex = min - 1;
  }

  async function ordenarByAndRender() {
    ordenarPorZIndex();
    await renderizarItems(state.thumbs);
    guardarDebounced();
  }

  return {
    ensureMapExists,
    cargarThumbnailsYRenderizar,
    mostrarAvisoPendientesEncuadrar,
    encuadrarItemDirecto,
    mostrarAvisoDriveNoAutorizado,
    precargarRatioImagen,
    renderizarItems,
    cargarImagen,
    encuadrarSeleccionado,
    agregarMapa,
    toggleWallSelected,
    deleteSelected,
    sameWallVisibleItems,
    alignSelected,
    distributeSelected,
    bringSelectedToFront,
    sendSelectedToBack,
    ordenarByAndRender,
  };
}